import { useState } from 'react';

import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './CommissionConsentAction.messages';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';
import { CommissionConsentModal } from './commissionConsentModal/CommissionConsentModal';
import { FormalOffer } from '../../../myOffers/MyOffers.types';

export const CommissionConsentAction = ({
    status,
    formalOffer,
    triggerRefetchFundingRequirements
}: {
    status: TFundingRequirementsSteps['0']['status'];
    formalOffer: FormalOffer;
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    function onConfirm() {
        triggerRefetchFundingRequirements();
        setIsModalOpen(false);
    }

    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    status === 'COMPLETED' ? (
                        <Button
                            variant="secondary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            <FormattedMessage {...messages.completedAction} />
                        </Button>
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => setIsModalOpen(true)}
                            data-testId="commission-consent-action-button"
                        >
                            <FormattedMessage {...messages.action} />
                        </Button>
                    )
                }
            />

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                closeIcon
            >
                <CommissionConsentModal
                    formalOffer={formalOffer}
                    isReadOnly={status === 'COMPLETED'}
                    onConfirm={onConfirm}
                />
            </Modal>
        </>
    );
};
